export default __webpack_public_path__ + "static/media/640_portfolio02-es-web.1a4e04b6.png";